// Einstieg der neuen Oberfläche (Layouts app und auth): Turbo Drive mit
// eigenem Bestätigungsdialog und Stimulus. Keine Turbo Frames/Streams.
// Muss vor Turbo ausgewertet werden (popstate-Reihenfolge, siehe Datei)
import "./turbo_history_bridge"
import * as Turbo from "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"

import { confirmDialog } from "./confirm_dialog"
import AlternateSubmitController from "./controllers/alternate_submit_controller"
import AutosubmitController from "./controllers/autosubmit_controller"
import AuthScreenController from "./controllers/auth_screen_controller"
import ClipboardController from "./controllers/clipboard_controller"
import DateRangeController from "./controllers/date_range_controller"
import DependentSelectController from "./controllers/dependent_select_controller"
import FlashController from "./controllers/flash_controller"
import LectureFreePeriodsController from "./controllers/lecture_free_periods_controller"
import ReactMountController from "./controllers/react_mount_controller"
import TabsController from "./controllers/tabs_controller"
import ThemeController from "./controllers/theme_controller"
import TimespanController from "./controllers/timespan_controller"
import TomSelectController from "./controllers/tom_select_controller"
import VacationPreviewController from "./controllers/vacation_preview_controller"

// data-turbo-confirm zeigt statt window.confirm ein <dialog>
Turbo.config.forms.confirm = confirmDialog

const application = Application.start()
application.register("alternate-submit", AlternateSubmitController)
application.register("auth-screen", AuthScreenController)
application.register("autosubmit", AutosubmitController)
application.register("clipboard", ClipboardController)
application.register("date-range", DateRangeController)
application.register("dependent-select", DependentSelectController)
application.register("flash", FlashController)
application.register("lecture-free-periods", LectureFreePeriodsController)
application.register("react-mount", ReactMountController)
application.register("tabs", TabsController)
application.register("theme", ThemeController)
application.register("timespan", TimespanController)
application.register("tom-select", TomSelectController)
application.register("vacation-preview", VacationPreviewController)
